export default __webpack_public_path__ + "static/media/quotationIcon.936bc5ba.svg";